import { forwardRef } from "react";
import { ProgressBarText } from "./components/ProgressText/index.js";
import { Progress, ProgressBackground, ProgressBarContainer, ProgressCircle, StyledCircleProgressBar, SVG } from "./ProgressBar.style.js";
import { DefaultProgressBarProps, ProgressBarProps } from "./ProgressBar.types.js";

const defaultProps: DefaultProgressBarProps = {
    rounded: false,
    color: "primary",
    showLabel: true,
    verticalPlacement: "bottom",
    horizontalPlacement: "left",
    size: "large",
};

/**
 * @deprecated This component should not be used directly.
 * Use {@link ProgressBarV2} instead which provides the complete progress bar functionality.
 * This component will be removed in a future version.
 */
export const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>((props, ref): JSX.Element => {
    const {
        rounded,
        value,
        showLabel,
        doneTitle,
        horizontalPlacement,
        verticalPlacement,
        color,
        backgroundColor,
        indeterminate,
        renderLabel,
        height,
        size,
        progressBarTextColor,
        ...attributes
    } = {
        ...defaultProps,
        ...props,
    };

    const ProgressBarComponent = (): JSX.Element => {
        if (rounded) {
            return (
                <StyledCircleProgressBar ref={ref} size={size} {...attributes}>
                    <SVG>
                        <ProgressCircle type="background" backgroundColor={backgroundColor} />
                        <ProgressCircle color={color} value={value} type="progress" indeterminate={indeterminate} />
                    </SVG>
                    {showLabel &&
                        (renderLabel ? (
                            renderLabel({
                                ...defaultProps,
                                ...props,
                            })
                        ) : (
                            <ProgressBarText
                                size={size}
                                value={value}
                                doneTitle={doneTitle}
                                orientation="column"
                                progressBarTextColor={progressBarTextColor}
                            />
                        ))}
                </StyledCircleProgressBar>
            );
        }
        return (
            <ProgressBarContainer {...attributes}>
                {verticalPlacement === "top" &&
                    showLabel &&
                    (renderLabel ? (
                        renderLabel({
                            ...defaultProps,
                            ...props,
                        })
                    ) : (
                        <ProgressBarText
                            size={size}
                            value={value}
                            doneTitle={doneTitle}
                            textAlign={horizontalPlacement}
                            orientation="row"
                            progressBarTextColor={progressBarTextColor}
                        />
                    ))}
                <ProgressBackground backgroundColor={backgroundColor} height={height}>
                    <Progress color={color} value={value} indeterminate={indeterminate} />
                </ProgressBackground>
                {verticalPlacement === "bottom" &&
                    showLabel &&
                    (renderLabel ? (
                        renderLabel({
                            ...defaultProps,
                            ...props,
                        })
                    ) : (
                        <ProgressBarText
                            size={size}
                            value={value}
                            doneTitle={doneTitle}
                            textAlign={horizontalPlacement}
                            orientation="row"
                            progressBarTextColor={progressBarTextColor}
                        />
                    ))}
            </ProgressBarContainer>
        );
    };

    return ProgressBarComponent();
});
